import { AllowedCss, CSS_SELECTOR } from './interface';

const buttonsCss: AllowedCss = {
  directives: ['border', 'font', 'height', 'margin', 'padding', 'width'],
  selector: CSS_SELECTOR.BUTTONS,
};
const buttonsContainerCss: AllowedCss = {
  directives: ['flex'],
  selector: CSS_SELECTOR.BUTTONS_CONTAINER,
};
const languageSwitchCss: AllowedCss = {
  directives: ['background', 'color', 'font-size'],
  selector: CSS_SELECTOR.LANGUAGE_SWITCH,
};
const layerCss: AllowedCss = {
  directives: ['border', 'height', 'margin', 'padding', 'width'],
  selector: CSS_SELECTOR.LAYER,
};
const linksCss: AllowedCss = {
  directives: ['font', 'text'],
  selector: CSS_SELECTOR.LINKS,
};
const messageCss: AllowedCss = { directives: ['color', 'font'], selector: CSS_SELECTOR.MESSAGE };
const tabButtonCss: AllowedCss = {
  directives: ['background', 'font', 'height', 'margin', 'padding', 'text', 'width'],
  selector: CSS_SELECTOR.TAB_BUTTON,
};
const tabContentCss: AllowedCss = {
  directives: ['background', 'color', 'margin', 'padding'],
  selector: CSS_SELECTOR.TAB_CONTENT,
};
const titleCss: AllowedCss = { directives: ['color', 'font', 'text'], selector: CSS_SELECTOR.TITLE };

export const allowedRules = [
  buttonsCss,
  buttonsContainerCss,
  languageSwitchCss,
  layerCss,
  linksCss,
  messageCss,
  tabButtonCss,
  tabContentCss,
  titleCss,
];
